<template>
    <div class="bg-grey full-height">
    
        <CRow class="m-0 justify-content-center align-items-center">
            <CCol sm="12" xs="6" class="text-right">
                <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                    <img style="max-width: 40px; float: left; margin-right: 5px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                    <span style="margin-top:20px">Verify Code</span>
                </h5>
    
            </CCol>
    
            <CCol md="8" class="text-center mt-3 d-none d-sm-block" style="width: 90%; background-size: cover; margin: auto;">
                <h5 class="custom-18px poppin-font mt-2 text-left">Verify Code</h5>
                <div class="ustom-sub-title-app text-left mb-5 poppin-font">
                    Please enter the code we just sent to {{ email }}
                </div>
                <div class="verification-input">
                    <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                    <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                    <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                    <input v-model="code[3]" maxlength="1" style="width:20%" @change="submitVerification" class="custom-code" />
                </div>
            </CCol>
            <!-- Column for mobile view -->
            <CCol xs="12" class="text-center mt-3 d-sm-none" style="width: 100%; background-size: cover; margin: auto;">
                <h5 class="custom-18px poppin-font mt-2 text-left ml-4">Verify Code</h5>
                <div class="ustom-sub-title-app text-left mb-5 poppin-font ml-4">
                    Please enter the code we just sent to {{ email }}
                </div>
                <div class="verification-input">
                    <input v-model="code[0]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                    <input v-model="code[1]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                    <input v-model="code[2]" maxlength="1" style="width:20%" class="custom-code mr-2" />
                    <input v-model="code[3]" maxlength="1" style="width:20%" @change="submitVerification" class="custom-code" />
                </div>
            </CCol>
                <!-- <h5 class="custom-14px poppin-font mt-2 text-center">Resend code in 00:48</h5> -->

        
    
        </CRow>

        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/SuccessSubmit.png" />
                    <h3 class="custom-20px-500 text-center">Check Email </h3>
                    <label class="custom-12px-500">To reset your password, please refer to the email we just sent you.</label>
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToWishes()">Confirm Now</CButton>
           
                </div>
            </div>
        </div>

        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <input v-model="newPassword" type="password" class="custom-input-app" placeholder="New Password"/> 
                    <input v-model="confirmPassword"  type="password" class="custom-input-app mt-2" placeholder="Confirm Password" /> 
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="ChangePassword()">Reset Password</CButton>
                </div>
            </div>
        </div>

        <!-- <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all" @click="closePopup1">
            <div class="popup-all1">
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/SuccessChek.png" />
                    <h3 class="custom-20px-500 text-center">Success</h3>
                    <label class="custom-12px-500">Your password is succesfully created</label>
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToWishes()">Success</CButton>
                </div>
            </div>
        </div> -->
    </div>
</template>


<script>
export default ({
    data() {
        return {
            isLanguagePopupVisible: false,
            isLanguagePopupVisible1: false,
            code: ["", "", "", ""],
            email : this.$route.query.email, 
            newPassword: "",
            confirmPassword: "",
            verificationCode: "",

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },

        GoToLogin() {
            // Close the popup and backdrop
            this.$router.push("/RegisterHomepage");
        },

        GoToChangePassword() {
            // Close the popup and backdrop
            this.$router.push("/ChangePassword");
        },
        submitVerification() {
            this.verificationCode = this.code.join(""); // Concatenate the digits
             console.log("Verification Code:", this.verificationCode);
             this.ValidateCode(this.verificationCode);
             this.isLanguagePopupVisible = true;

            // this.popupSuccess = true;

           
        },

        closePopup() {
            this.isLanguagePopupVisible = false;
        },
        GoToWishes()
        {
            this.isLanguagePopupVisible1 = true;
            this.isLanguagePopupVisible = false;

        },
        closePopup1() {
            this.isLanguagePopupVisible = false;
            this.$router.push("UploadImage");
        },
        ValidateCode(verificationCode) {
      this.SubmittedForm = true;
      this.VerifiedForm = true;
      this.verify = true;
      
      const formData = new FormData();

      formData.append("userEmail", this.$route.query.email);
       formData.append("code", verificationCode);

      return this.$API
        .post(this.$ValidateForgotPasswordCode, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.isLanguagePopupVisible1 = true;
            this.isLanguagePopupVisible = false;
          // this.ChangePassword(verificationCode);
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

            this.ErrorMessage = true;
          }
        });
    },
    ChangePassword() {
        this.isLanguagePopupVisible = false;
      const formData = new FormData();

      formData.append("userEmail", this.$route.query.email);
       formData.append("code", this.verificationCode);
        formData.append("newPassword", this.newPassword);

      return this.$API
        .post(this.$ChangePassword, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.verify = true;
            this.SuccessMessage = true;
            this.isLanguagePopupVisible1 = false;
            this.$router.push("/Login");
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

            this.ErrorMessage = true;
          }
        });
    },

    }
})
</script>
